import { useChannels } from '../api/hooks.ts'
import { haptic } from '../telegram/haptics.ts'
import { Chip } from './Chip.tsx'
import { Field, SwitchRow, Textarea } from './Input.tsx'
import { Section } from './List.tsx'

// «📣 Проверить публикацию»: задача закроется сама, когда в канале выйдет подходящий пост.

export interface PublishValue {
  enabled: boolean
  /** null — любой подключённый канал. */
  channelId: number | null
  /** Какой пост ждём: описание или образец. */
  expected: string
}

export const EMPTY_PUBLISH: PublishValue = { enabled: false, channelId: null, expected: '' }

/** Тело для API: null — проверка выключена или не описан пост. */
export function publishBody(v: PublishValue): { channelId: number | null; expected: string } | null {
  return v.enabled && v.expected.trim().length >= 3
    ? { channelId: v.channelId, expected: v.expected.trim() }
    : null
}

export function publishInvalid(v: PublishValue): boolean {
  return v.enabled && v.expected.trim().length < 3
}

export function PublishCheckFields({
  value,
  onChange,
}: {
  value: PublishValue
  onChange: (v: PublishValue) => void
}) {
  const channels = useChannels()
  const list = channels.data ?? []
  const set = (patch: Partial<PublishValue>) => onChange({ ...value, ...patch })
  return (
    <>
      <Section id="publish">
        <SwitchRow
          label="📣 Проверить публикацию в канале"
          hint={
            value.enabled
              ? 'Задача закроется сама, когда в канале выйдет подходящий пост'
              : 'Для задач вроде «опубликовать промо-пост»'
          }
          checked={value.enabled}
          onChange={(v) => set({ enabled: v })}
        />
      </Section>
      {value.enabled && (
        <>
          {list.length === 0 ? (
            <div className="hint hint--attn">
              Бот пока не подключён ни к одному каналу. Добавьте его в канал администратором — канал появится
              здесь. До этого проверка будет смотреть все подключённые каналы.
            </div>
          ) : (
            <Field label="Канал">
              {() => (
                <div className="chips chips--wrap" role="radiogroup" aria-label="Канал">
                  <Chip
                    selected={value.channelId === null}
                    onClick={() => {
                      haptic.selection()
                      set({ channelId: null })
                    }}
                  >
                    Любой
                  </Chip>
                  {list.map((c) => (
                    <Chip
                      key={c.id}
                      selected={value.channelId === c.id}
                      onClick={() => {
                        haptic.selection()
                        set({ channelId: c.id })
                      }}
                    >
                      {c.title}
                    </Chip>
                  ))}
                </div>
              )}
            </Field>
          )}
          <Field
            label="Какой пост ждём"
            hint="ИИ сравнит новые посты канала с этим описанием. Тексты могут меняться каждый день — опишите суть; если промокод всегда один — впишите его."
            error={
              value.expected.trim() && publishInvalid(value) ? 'Опишите пост хотя бы парой слов' : undefined
            }
          >
            {(fid) => (
              <Textarea
                id={fid}
                rows={3}
                maxLength={2000}
                value={value.expected}
                onChange={(e) => set({ expected: e.target.value })}
                placeholder="Например: промо-пост с промокодом на бонус к депозиту и ссылкой на сайт"
              />
            )}
          </Field>
        </>
      )}
    </>
  )
}
